import CircleIcon from "@mui/icons-material/Circle";
import { Alert, Autocomplete, Box, Button, Checkbox, Tab, Tabs, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import { tenant } from "../../tenant";
import toast from "react-hot-toast";
import GenericForm from "../genericForm";
import GenericTable from "../genericTable";
// GraphQL imports removed - now using REST API

let wbsDataOriginal = [];

function YardEdit() {
	const authContext = useContext(AuthContext);
	const [activeTab, setActiveTab] = useState(0);
	const { id } = useParams();
	const navigate = useNavigate();
	const columnHelper = createMRTColumnHelper();

	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const [personalData, setPersonalData] = useState({}); // Dati personali da query
	const [associatedAreaRolesData, setAssociatedAreaRolesData] = useState([]); // Dati delle aree associate
	const [wbsData, setWbsData] = useState([]); // Dati dei contatti
	const [showformAree, setShowFormAree] = useState(false);
	const [suppliersArea, setSuppliersArea] = useState([]);
	const [editAreaRole, setEditAreaRole] = useState(false);
	const [editAreaRoleData, setEditAreaRoleData] = useState({});
	const [userOption, setUserOption] = useState([]);
	const [rolesOption, setRolesOption] = useState([]);
	const [rolesDocumentsOption, setRolesDocumentsOption] = useState([]);
	const [selectedRolesDocuments, setSelectedRolesDocuments] = useState([]);
	const [rolesDocumentsFormData, setRolesDocumentsFormData] = useState([]);
	const [loadingRolesDocumentFormData, setLoadingRolesDocumentFormData] = useState(false);
	const [suppliersOption, setSuppliersOption] = useState([]);
	const [originalUserOption, setOriginalUserOption] = useState([]);
	const [wbsFormData, setWbsFormData] = useState([]);
	const [selectedSuppliers, setSelectedSuppliers] = useState([]);
	const [error, seterror] = useState("");

	const handleSetNotification = (msg, severityType) => {
		toast[severityType](msg, {
			id: "yard-edit-notification-toast",
		});
	};

	function fetchPersonal() {
		apiService
			.get("/area-management/", { id: id }, {})
			.then((data) => {
				setPersonalData({ ...data, id: id });
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #009835"
				)
			);
	}

	function fetchAreaSuppliers() {
		apiService
			.get("/suppliers-area-management/", { id_area: id }, {})
			.then((data) => {
				setSuppliersArea({ suppliers: data, id_area: id });
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #003139835"
				)
			);
	}

	function fetchRolesDocumentOption() {
		apiService
			.get("/role-documents-management/", {}, {})
			.then((data) => {
				setRolesDocumentsOption(data);
			})
			.catch((error) => {
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #003139835"
				);
			});
	}

	function fetchRolesDocumentsFormData() {
		setLoadingRolesDocumentFormData(true);
		apiService
			.get("/area-personal-managment/", { area_id: id }, {})
			.then((data) => {
				setLoadingRolesDocumentFormData(false);
				setRolesDocumentsFormData(data["formData"]);
				setSelectedRolesDocuments(data["existingIds"]);
			})
			.catch((error) => {
				setLoadingRolesDocumentFormData(false);
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #003139835"
				);
			});
	}

	function fetchAreaRoles() {
		apiService
			.get("/area-management/user-roles/", { id: id }, {})
			.then((data) => {
				setAssociatedAreaRolesData(data);
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #009836"
				)
			);
	}

	function fetchAreaJobs() {
		apiService
			.get("/jobs-area", { id_area: id }, {})
			.then((data) => {
				wbsDataOriginal = [...data];
				setWbsData([...data]);
				setWbsFormData([...data]);
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #009896"
				)
			);
	}

	function fetchUserOption() {
		apiService
			.get("/area-management/user-roles/", { id: id, get_option: true }, {})
			.then((data) => {
				setUserOption(data);
				setOriginalUserOption(data);
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei fornitori. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #009846"
				)
			);
	}

	useEffect(() => {
		/*
		 * FETCH DELLE OPZIONI DELLE AUTOCOMPLETE
		 */

		fetchUserOption();
		fetchRolesDocumentOption();

		apiService
			.get("/role-management/", {}, {})
			.then((data) => {
				if (data) setRolesOption(data);
			})
			.catch((error) => {
				console.log(error);
				seterror(
					"Qualcosa è andato storto durante il caricamento dei ruoli. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #009839"
				);
			});

		apiService
			.get("/suppliers-management/", {}, {})
			.then((data) => {
				if (data) setSuppliersOption([...data, { id: -1, name: "Interno" }]);
			})
			.catch((error) => {
				console.log(error);
				seterror(
					"Qualcosa è andato storto durante il caricamento dei fornitori. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0000843"
				);
			});
		/*
		 * FINE FETCH DELLE OPZIONI DELLE AUTOCOMPLE
		 */

		fetchPersonal();
		fetchAreaSuppliers();
		fetchAreaJobs();
		fetchRolesDocumentsFormData();
	}, []);

	async function deleteResource(params, endpoint) {
		try {
			// Parametri opzionali per la richiesta DELETE
			const headers = {}; // Headers opzionali

			// Esegui la chiamata DELETE
			const response = await apiService.delete(endpoint, params, headers);

			// Se arriviamo qui, la chiamata è andata a buon fine
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);

			// Puoi fare qualcosa con la risposta, se necessario
			return response;
		} catch (error) {
			// Gestisci eventuali errori
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

			// Puoi gestire l'errore in modo specifico, ad esempio:
			if (error.message.includes("404")) {
				console.log(`La risorsa con id ${id} non è stata trovata`);
			} else if (error.message.includes("403")) {
				console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
			}

			// Rilancia l'errore se vuoi che venga gestito a un livello superiore
			throw error;
		}
	}

	function handleDelete(id, endpoint, resource, errorCode, sezione) {
		deleteResource(id, endpoint)
			.then((result) => {
				toast.success(`${resource} eliminato con successo`);
				if (sezione === "area-roles") {
					fetchAreaRoles();
					fetchUserOption();
				} else if (sezione === "contacts") {
				}
			})
			.catch((error) => {
				toast.error(
					`Si è verificato un errore durante l'eliminazione del ${resource}. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #${errorCode}`
				);
			});
	}

	const handleDeleteRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			handleDelete({ id_user: id_row, id: id }, "/area-management/user-roles/", "Utente", "00897345", sezione);
		} else if (sezione === "contacts") {
			handleDelete({ id_contact: id_row, id_user: id, internal: false }, "/user-management/contacts/", "contact", "000346", sezione);
		}
	};

	const handleEditRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			setEditAreaRole(true);
			apiService
				.get("/area-management/user-roles/", { id: id, user_id: id_row }, {})
				.then((data) => {
					setEditAreaRoleData(data);
					setShowFormAree(true);
				})
				.catch((error) =>
					seterror(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #098369"
					)
				);
		}
	};

	const filter = (filters) => {
		// Se filters è vuoto, ritorna l'intera lista userOption
		let apply = true;
		if (Object.keys(filters).length === 0) apply = false;

		const filteredData = originalUserOption.filter((row) => {
			return Object.keys(filters).every((key) => {
				const values = filters[key];

				// Se values è vuoto o nullo, consideriamo la condizione soddisfatta (non filtriamo)
				if (!values || values.length === 0) return true;

				// Verifica che il valore di row[key] sia presente nell'array filters[key]
				return values.includes(row[key]);
			});
		});

		if (apply) {
			setUserOption(filteredData);
		} else {
			setUserOption(originalUserOption);
		}
	};

	function onSuccessUserAuthArea() {
		fetchUserOption();
		setShowFormAree(false);
	}

	useEffect(() => {
		if (!showformAree) fetchAreaRoles();
	}, [showformAree]);

	const handleCheckboxChange = (e, row) => {
		row.original.associated_in_yard = e.target.checked;
		const isChecked = e.target.checked;

		// Aggiorna lo stato immutabilmente
		const updatedData = wbsFormData.map((item) => (item.id === row.original.id ? { ...item, associated_in_yard: isChecked } : item));

		setWbsFormData(updatedData);
	};

	const handleNameChange = (e, row) => {
		row.original.name = e.target.value;
		const updatedName = e.target.value;

		// Aggiorna i dati direttamente in modo immutabile
		const updatedData = wbsFormData.map((item) => (item.id === row.original.id ? { ...item, name: updatedName } : item));

		setWbsFormData(updatedData);
	};

	function handleSaveRolesDocuments() {
		const elementWithZeroQuantity = rolesDocumentsFormData.filter((item) => item.qta <= 0);

		if (elementWithZeroQuantity.length > 0) {
			toast.error("Quantità non valida");
			return;
		}

		apiService
			.post("/area-personal-managment/", {}, { data: rolesDocumentsFormData, area_id: id })
			.then((data) => {
				fetchRolesDocumentsFormData();
				toast.success("Documenti salvati con successo");
			})
			.catch((error) => {
				toast.error(
					"Errore durante il salvataggio dei documenti. Riprova più tardi se l'errore persiste contatti il supporto tecnico indicato l'errore #0000843"
				);
			});
	}

	// function handleSave(id, endpoint, resource, errorCode, sezione) {
	//	saveYard(id, endpoint)
	//		.then((result) => {
	//			toast.success(`${resource} salvato con successo`);
	//		})
	//		.catch((error) => {
	//			// Gestisci l'errore se non è stato gestito nella funzione
	//			toast.error(`Si è verificato un errore durante il salvataggio del ${resource}. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #${errorCode}`);
	//		});
	// }

	return (
		<DashboardLayout>
			{authContext.hasAuth("EDIT_AREE") ? (
				<>
					<DashboardNavbar />
					<Box sx={{ width: "100%" }}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => navigate("/yard-managment")}
							sx={{
								mt: 2,
								alignSelf: "center",
								minWidth: "100px",
								color: "#ffffff",
								marginBottom: "30px",
							}}
						>
							Torna alla tabella cantieri
						</Button>
						<Tabs value={activeTab} onChange={handleChange} centered>
							<Tab label="Dati cantiere" />
							<Tab
								label={
									<>
										<span>Operatori associati</span>
										<span>
											{associatedAreaRolesData.length === 0 && (
												<CircleIcon
													color="error"
													fontSize={"small"}
													sx={{
														color: "#B71C1C",
														marginLeft: "10px",
														marginTop: "6px",
													}}
												/>
											)}
										</span>
									</>
								}
							/>
							<Tab
								label={
									<>
										<span>WBS associate</span>
										<span>
											{wbsData.length === 0 && (
												<CircleIcon
													color="error"
													fontSize={"small"}
													sx={{
														color: "#B71C1C",
														marginLeft: "10px",
														marginTop: "6px",
													}}
												/>
											)}
										</span>
									</>
								}
							/>
							<Tab
								label={
									<>
										<span>Fornitori associati</span>
										<span>
											{suppliersArea?.suppliers?.length === 0 && (
												<CircleIcon
													color="error"
													fontSize={"small"}
													sx={{
														color: "#B71C1C",
														marginLeft: "10px",
														marginTop: "6px",
													}}
												/>
											)}
										</span>
									</>
								}
							/>
						</Tabs>

						<TabPanel value={activeTab} index={0}>
							<GenericForm
								authModelName={"AREE"}
								old_data={personalData}
								url="/area-management/"
								useAPI={true} // cambia a true per usare l'API
								executeOnSuccess={true}
								executeOnSuccessTask={fetchPersonal}
								requiredFields={[
									{
										name: "name",
										nameDisplayed: "nome cantiere",
									},
									{
										name: "location",
										nameDisplayed: "posizione del cantiere",
									},
									{
										name: "external_code",
										nameDisplayed: "codice commessa",
									},
									{
										name: "client",
										nameDiplayed: "committente",
									},
								]}
								inputFields={[
									{
										type: "text",
										name: "name", // Nome nel DB
										label: "Nome cantiere", // Etichetta visibile
									},
									{
										type: "text",
										name: "external_code", // Nome nel DB
										label: "Codice commessa", // Etichetta visibile
									},
									{
										type: "text",
										name: "client", // Nome nel DB
										label: "Committente", // Etichetta visibile
									},
									{
										type: "textarea",
										name: "description", // Nome nel DB
										label: "descrizione cantiere", // Etichetta visibile
										rows: 5,
									},
									{
										type: "map",
										name: "location",
										label: "Posizione geografica",
									},
								]}
							/>
						</TabPanel>

						<TabPanel value={activeTab} index={1}>
							{authContext.hasAuth("VIEW_USERROLEAUTHAREA") ? (
								<>
									{authContext.hasAuth("ADD_USERROLEAUTHAREA") ||
									(showformAree && authContext.hasAuth("EDIT_USERROLEAUTHAREA")) ? (
										<center>
											<Button
												variant="contained"
												color="info"
												onClick={() => {
													setShowFormAree(!showformAree);
													setEditAreaRole(false);
													console.log("ciao,", showformAree);
												}}
												sx={{
													mt: 2,
													alignSelf: "center",
													minWidth: "100px",
													color: "#000000",
													marginBottom: "30px",
													marginTop: "20px",
												}}
											>
												{showformAree ? "Torna alla tabella" : "Aggiungi"}
											</Button>
										</center>
									) : null}
									{error !== "" ? (
										<Alert severity="error">{error}</Alert>
									) : !showformAree ? (
										<GenericTable
											authModelName={"USERROLEAUTHAREA"}
											columns={[
												columnHelper.accessor("name", {
													header: "name",
													size: 120,
												}),
												columnHelper.accessor("roles", {
													header: "Ruoli",
													size: 200,
												}),
												columnHelper.accessor("supplier", {
													header: "Fornitore",
													size: 200,
												}),
											]}
											data={associatedAreaRolesData}
											onDelete={(id) => handleDeleteRow(id, "area-roles")}
											onEdit={(id) => handleEditRow(id, "area-roles")}
										/>
									) : !editAreaRole ? (
										<>
											<MDBox sx={{ marginBottom: "20px" }}>
												<MDTypography
													variant="h6"
													sx={{
														marginBottom: "10px",
														textAlign: "center",
													}}
												>
													Filtra Operatori per fornitore
												</MDTypography>
												<MDBox
													sx={{
														display: "flex",
														border: "1px solid #1976d2",
														borderRadius: "10px",
														padding: "15px",
														overflowX: "auto",
														gap: "10px",
														"&::-webkit-scrollbar": {
															height: "8px",
														},
														"&::-webkit-scrollbar-track": {
															backgroundColor: "#f1f1f1",
															borderRadius: "4px",
														},
														"&::-webkit-scrollbar-thumb": {
															backgroundColor: "#888",
															borderRadius: "4px",
														},
														"&::-webkit-scrollbar-thumb:hover": {
															backgroundColor: "#555",
														},
													}}
												>
													{suppliersOption.map((supplier, i) => (
														<Button
															key={i}
															variant={selectedSuppliers.includes(supplier.id) ? "contained" : "outlined"}
															color="primary"
															sx={{
																minWidth: "120px",
																whiteSpace: "nowrap",
																backgroundColor: selectedSuppliers.includes(supplier.id)
																	? "#1976d2"
																	: "#ffffff",
																color: selectedSuppliers.includes(supplier.id) ? "#ffffff" : "#1976d2",
																borderColor: "#1976d2",
																"&:hover": {
																	backgroundColor: selectedSuppliers.includes(supplier.id)
																		? "#1565c0"
																		: "#f5f5f5",
																},
															}}
															onClick={() => {
																const newSelectedSuppliers = selectedSuppliers.includes(supplier.id)
																	? selectedSuppliers.filter((id) => id !== supplier.id)
																	: [...selectedSuppliers, supplier.id];
																setSelectedSuppliers(newSelectedSuppliers);
																filter({
																	supplier: newSelectedSuppliers,
																});
															}}
														>
															{supplier.name}
														</Button>
													))}
												</MDBox>
											</MDBox>
											{userOption.length > 0 ? (
												<GenericForm
													authModelName={"USERROLEAUTHAREA"}
													formData={{ id: id }}
													url="/area-management/user-roles/"
													useAPI={true}
													executeOnSuccess={true}
													executeOnSuccessTask={onSuccessUserAuthArea}
													requiredFields={[
														{
															name: "users",
															nameDiplayed: "operatori",
														},
														{
															name: "roles",
															nameDiplayed: "ruoli associati",
														},
													]}
													inputFields={[
														{
															type: "autocomplete",
															name: "users", // Nome nel DB
															label: "Operatori", // Etichetta visibile
															multiple: true,
															options: userOption,
															valueToDisplay: (value, options) => {
																// Controlla se `value` è un oggetto
																if (typeof value === "object") {
																	return `${value.name}`; // Mostra direttamente le informazioni
																}
																// Se `value` è un ID (numero)
																const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
																return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
															},

															valueToSave: (selected) => {
																// Se `selected` è un array
																if (Array.isArray(selected)) {
																	// Crea un insieme di ID esistenti per evitare duplicati
																	const existingIds = new Set(
																		selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
																	);

																	// Aggiungi il nuovo ID solo se non è già presente
																	return Array.from(existingIds);
																}

																// Se `selected` è un singolo oggetto, restituisci il suo ID
																return selected?.id;
															},
															valueComparator: (option, value) => {
																// Controlla se `value` è un numero (ID)
																if (typeof value === "number") {
																	return option.id === value; // Confronta l'ID dell'opzione con il valore
																}

																// Se `value` è un oggetto, confronta l'ID
																return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
															},
														},
														{
															type: "autocomplete",
															name: "roles", // Nome nel DB
															label: "Ruoli associati", // Etichetta visibile
															multiple: true,
															options: rolesOption,
															valueToDisplay: (value, options) => {
																// Controlla se `value` è un oggetto
																if (typeof value === "object") {
																	return `${value.name}`; // Mostra direttamente le informazioni
																}
																// Se `value` è un ID (numero)
																const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
																return option ? `${option.name}` : "ruolo non trovato"; // Messaggio se non trovato
															},

															valueToSave: (selected) => {
																// Se `selected` è un array
																if (Array.isArray(selected)) {
																	// Crea un insieme di ID esistenti per evitare duplicati
																	const existingIds = new Set(
																		selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
																	);

																	// Aggiungi il nuovo ID solo se non è già presente
																	return Array.from(existingIds);
																}

																// Se `selected` è un singolo oggetto, restituisci il suo ID
																return selected?.id;
															},
															valueComparator: (option, value) => {
																// Controlla se `value` è un numero (ID)
																if (typeof value === "number") {
																	return option.id === value; // Confronta l'ID dell'opzione con il valore
																}

																// Se `value` è un oggetto, confronta l'ID
																return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
															},
														},
													]}
												/>
											) : (
												<>
													<Box
														component="form"
														sx={{
															display: "flex",
															flexDirection: "column",
															gap: 2,
															padding: 3,
															borderRadius: 2,
															backgroundColor: "#f5f5f5", // Grigio chiaro per il filtro
															boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Ombreggiatura delicata per un effetto leggero
														}}
													>
														<center>
															<MDTypography>Hai già inserito tutti gli operatori</MDTypography>
														</center>
													</Box>
												</>
											)}
										</>
									) : (
										<>
											<GenericForm
												authModelName={"USERROLEAUTHAREA"}
												old_data={{
													...editAreaRoleData,
													id: id,
												}}
												url="/area-management/user-roles/"
												useAPI={true}
												requiredFields={[]}
												inputFields={[
													{
														type: "custom",
														name: "customTitle", // Nome per identificazione
														component: () => (
															<Typography variant="h6" color="textSecondary">
																Operatore:
																{editAreaRoleData.name}
																<br /> Fornitore : {editAreaRoleData.supplier}
															</Typography>
														), // Componente personalizzato
													},
													{
														type: "autocomplete",
														name: "roles", // Nome nel DB
														label: "Ruoli associati", // Etichetta visibile
														multiple: true,
														options: rolesOption,
														valueToDisplay: (value, options) => {
															// Controlla se `value` è un oggetto
															if (typeof value === "object") {
																return `${value.name}`; // Mostra direttamente le informazioni
															}
															// Se `value` è un ID (numero)
															const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
															return option ? `${option.name}` : "ruolo non trovato"; // Messaggio se non trovato
														},

														valueToSave: (selected) => {
															// Se `selected` è un array
															if (Array.isArray(selected)) {
																// Crea un insieme di ID esistenti per evitare duplicati
																const existingIds = new Set(
																	selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
																);

																// Aggiungi il nuovo ID solo se non è già presente
																return Array.from(existingIds);
															}

															// Se `selected` è un singolo oggetto, restituisci il suo ID
															return selected?.id;
														},
														valueComparator: (option, value) => {
															// Controlla se `value` è un numero (ID)
															if (typeof value === "number") {
																return option.id === value; // Confronta l'ID dell'opzione con il valore
															}

															// Se `value` è un oggetto, confronta l'ID
															return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
														},
													},
												]}
											/>
										</>
									)}
								</>
							) : (
								<MDTypography>Non hai i permessi per visualizzare queste informazioni</MDTypography>
							)}
						</TabPanel>

						<TabPanel value={activeTab} index={2}>
							{authContext.hasAuth("VIEW_AREAJOBS") ? (
								<>
									<center>
										<Button
											type="submit"
											variant="contained"
											component="span"
											sx={{
												backgroundColor: "#514f4f",
												color: "white!important",
												mb: 2,
												width: "220px",
												height: "50px",
												fontSize: "16px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: "8px",
											}}
											onClick={() => {
												const flattenedData = wbsFormData.flatMap((row) => [row, ...row.subRows]);

												apiService
													.post(
														"/jobs-area/",
														{},
														{
															area: id,
															jobs: flattenedData,
														}
													)
													.then((data) => {
														toast.success("Operazione effettuata con successo");
														fetchAreaJobs();
													})
													.catch((error) => {
														fetchAreaJobs();
														toast.error(
															"Errore durante l'operazione. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00080"
														);
													});
											}}
										>
											SALVA
										</Button>
									</center>
									<MDBox
										style={{
											width: "100%",
											marginTop: "20px",
										}}
									>
										<GenericTable
											authModelName={"AREAJOBS"}
											pivotTable={true}
											sortingKey={"code"}
											columns={[
												columnHelper.accessor("code", {
													header: "Codice",
													size: 30,
												}),
												columnHelper.accessor("name", {
													header: "Nome",
													size: 200,
													Cell: ({ row }) => {
														return (
															<TextField
																sx={{
																	width: "100%",
																}}
																value={row.original.name}
																onChange={(e) => handleNameChange(e, row)}
															/>
														);
													},
												}),
												columnHelper.accessor("associated_in_yard", {
													header: "Applica",
													size: 30,
													Cell: ({ row }) => {
														return (
															<Checkbox
																checked={row.original.associated_in_yard}
																onChange={(e) => handleCheckboxChange(e, row)}
																sx={{
																	transform: "scale(1.5)", // Ingrandisce la Checkbox di 1.5 volte
																	"& .MuiSvgIcon-root": {
																		fontSize: 28,
																	}, // Ingrandisce l'icona all'interno della Checkbox
																}}
															/>
														);
													},
												}),
											]}
											data={wbsData}
											enableRowSelection={false}
										/>
									</MDBox>
								</>
							) : (
								<MDTypography>Non hai i permessi per visualizzare queste informazioni</MDTypography>
							)}
						</TabPanel>

						<TabPanel value={activeTab} index={3}>
							<GenericForm
								authModelName={"AREE"}
								old_data={suppliersArea}
								url="/suppliers-area-management/"
								useAPI={true} // cambia a true per usare l'API
								executeOnSuccess={true}
								executeOnSuccessTask={fetchAreaSuppliers}
								notChangeId={true}
								requiredFields={[
									{
										name: "suppliers",
										nameDisplayed: "Fornitori",
									},
								]}
								inputFields={[
									{
										type: "autocomplete",
										name: "suppliers",
										label: "Fornitori",
										multiple: true,
										options: suppliersOption,
										valueToDisplay: (value, options) => {
											// Controlla se `value` è un oggetto
											if (typeof value === "object") {
												return `${value.name}`; // Mostra direttamente le informazioni
											}
											// Se `value` è un ID (numero)
											const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
											return option ? `${option.name}` : "auth non trovata"; // Messaggio se non trovato
										},
										valueToSave: (selected) => {
											// Se `selected` è un array
											if (Array.isArray(selected)) {
												// Crea un insieme di ID esistenti per evitare duplicati
												const existingIds = new Set(
													selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
												);

												// Aggiungi il nuovo ID solo se non è già presente
												return Array.from(existingIds);
											}

											// Se `selected` è un singolo oggetto, restituisci il suo ID
											return selected?.id;
										},
										valueComparator: (option, value) => {
											// Controlla se `value` è un numero (ID)
											if (typeof value === "number") {
												return option.id === value; // Confronta l'ID dell'opzione con il valore
											}

											// Se `value` è un oggetto, confronta l'ID
											return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
										},
									},
								]}
							/>
						</TabPanel>
						<TabPanel value={activeTab} index={4}>
							<Box display="flex" flexDirection="column" alignItems="center">
								{!loadingRolesDocumentFormData ? (
									<>
										<Autocomplete
											options={rolesDocumentsOption}
											getOptionLabel={(option) => option.name}
											renderInput={(params) => <TextField {...params} label="Ruoli" />}
											value={selectedRolesDocuments}
											onChange={(event, newValue) => {
												setSelectedRolesDocuments(newValue);
												const oldData = rolesDocumentsFormData;
												const currentIds = new Set(oldData.map((item) => item.role_id));

												const newEntries = newValue
													.filter((item) => !currentIds.has(item.id))
													.map((item) => ({
														role_id: item.id,
														role_name: item.name,
														qta: 0,
													}));

												const updatedData = oldData.filter((item) =>
													newValue.some((selected) => selected.id === item.role_id)
												);

												setRolesDocumentsFormData([...updatedData, ...newEntries]);
											}}
											multiple
											sx={{ width: 800 }}
										/>

										<Button
											type="submit"
											variant="contained"
											component="span"
											sx={{
												backgroundColor: "#514f4f",
												color: "white!important",
												mb: 2,
												width: "220px",
												height: "50px",
												fontSize: "16px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												marginTop: "20px",
												gap: "8px",
											}}
											onClick={() => handleSaveRolesDocuments()}
										>
											SALVA
										</Button>

										<Box mt={1} width="100%" maxWidth={400}>
											{rolesDocumentsFormData?.map((item, index) => (
												<Box
													key={index}
													display="flex"
													flexDirection="column"
													alignItems="center"
													gap={1}
													mb={2}
													p={2}
													borderRadius={2}
													boxShadow={1}
													bgcolor="background.paper"
												>
													<Typography variant="h6" color="textSecondary">
														{item.role_name}
													</Typography>
													<TextField
														label="Quantità"
														type="number"
														variant="outlined"
														inputProps={{
															min: 0,
														}}
														value={item?.qta}
														onChange={(event) => {
															const value = Math.max(0, Number(event.target.value)); // Evita numeri negativi
															setRolesDocumentsFormData((prevData) =>
																prevData.map((el) =>
																	el.role_id === item.role_id
																		? {
																				...item,
																				qta: value,
																			}
																		: el
																)
															);
														}}
														sx={{
															width: "100px",
														}}
													/>
												</Box>
											))}
										</Box>
									</>
								) : (
									<CircularProgress
										size={120}
										sx={{
											marginTop: "250px",
											color: "#2b84ea",
										}}
									/>
								)}
							</Box>
						</TabPanel>
					</Box>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component="div">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default YardEdit;
